module.exports = __webpack_public_path__ + "img/img9.271c22f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/06/img9.png
// module id = 273
// module chunks = 0